import {DataGrid} from "@mui/x-data-grid";
//import { GridColDef } from '@mui/x-data-grid';
import { Paper, Typography, Button, FormControl, InputLabel, Select, MenuItem, Dialog, TextField, FormGroup} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { v4 as uuidv4 } from "uuid";
import {useEffect, useState} from "react"
import {CSVLink} from "react-csv"
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";
import { fetchTours, fetchDest, fetchdestToursbyDest, fetchTourbyId, updateTourdata, gettoursbydesc } from "../api/customerapi";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    headertext: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
  },
  
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(15),
      height: theme.spacing(6),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      justifyContent: "center",
    },
}));

const Listtourdata = () => {

const classes = useStyles();
const width = window.innerWidth-200;
//console.log(width);
const columns = [
    { field: 'tour_id', 
  headerName: ' Tour ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
    { field: 'tour_name', 
    headerName: ' Tour Name', 
    width: width/12*7,
    cellClassName: "gridcell"
    //align:"center",
    //headerAlign:"center"
    },
    {
      field: 'tour_city',
      headerName: 'City',
      width: width/12,
      
    },
    {
      field: 'advance_booking',
      headerName: 'Adv. Booking',
      width: width/12,
    },
    {
      field: 'tour_description',
      headerName: 'Description',
      width: width/12*2,
    },
    
  ];

  const columns2 = [
    { field: 'tour_id', 
  headerName: ' Tour ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
    { field: 'tour_name', 
    headerName: ' Tour Name', 
    width: width/12,
    cellClassName: "gridcell"
    //align:"center",
    //headerAlign:"center"
    },
    
    {
      field: 'tour_description',
      headerName: 'Description',
      width: width/12,
    },
    {
      field: 'A2',
      headerName: '2A',
      width: width/12,
    },
    {
      field: 'A3',
      headerName: '3A',
      width: width/12,
    },
    {
      field: 'A4',
      headerName: '4A',
      width: width/12,
    },
    {
      field: 'A5',
      headerName: '5A',
      width: width/12,
    },
    {
      field: 'A6',
      headerName: '6A',
      width: width/12,
    },
    {
      field: 'A7',
      headerName: '7A',
      width: width/12,
    },
    {
      field: 'A8',
      headerName: '8A',
      width: width/12,
    },
    {
      field: 'A9',
      headerName: '9A',
      width: width/12,
    },
     {
      field: 'A10',
      headerName: '10A',
      width: width/12,
    },
    {
      field: 'A1C1',
      headerName: '1A1C',
      width: width/12,
    },
    {
      field: 'A2C1',
      headerName: '2A1C',
      width: width/12,
    },
    {
      field: 'A2C2',
      headerName: '2A2C',
      width: width/12,
    },
    {
      field: 'A3C1',
      headerName: '3A1C',
      width: width/12,
    },
    {
      field: 'A3C2',
      headerName: '3A2C',
      width: width/12,
    },
    {
      field: 'A3C3',
      headerName: '3A3C',
      width: width/12,
    },
    {
      field: 'A4C1',
      headerName: '4A1C',
      width: width/12,
    },
    {
      field: 'A4C2',
      headerName: '4A2C',
      width: width/12,
    },
     {
      field: 'A4C3',
      headerName: '4A3C',
      width: width/12,
    },
     {
      field: 'A5C1',
      headerName: '5A1C',
      width: width/12,
    },
    {
      field: 'A5C2',
      headerName: '5A2C',
      width: width/12,
    },
     {
      field: 'A5C3',
      headerName: '5A3C',
      width: width/12,
    },
     {
      field: 'A6C1',
      headerName: '6A1C',
      width: width/12,
    },
    {
      field: 'A6C2',
      headerName: '6A2C',
      width: width/12,
    },
     {
      field: 'A6C3',
      headerName: '6A3C',
      width: width/12,
    },
    
  ];

  const headers=[
    {label:"Tour Id", key:"tour_id"},
        {label:"Name", key:"tour_name"},
  ]

  const headers2=[
    {label:"Tour Id", key:"tour_id"},
        {label:"Name", key:"tour_name"},
         {label:"Description", key:"tour_description"},
    {label:"2A", key:"A2"},
    {label:"3A", key:"A3"},
    {label:"4A", key:"A4"},
    {label:"5A", key:"A5"},
    {label:"6A", key:"A6"},
    {label:"7A", key:"A7"},
    {label:"8A", key:"A8"},
    {label:"9A", key:"A9"},
    {label:"9A", key:"A10"},
    {label:"1A1C", key:"A1C1"},
    {label:"2A1C", key:"A2C1"},
    {label:"3A1C", key:"A3C1"},
    {label:"3A2C", key:"A3C2"},
    {label:"3A3C", key:"A3C3"},
    {label:"4A1C", key:"A4C1"},
    {label:"2A2C", key:"A2C2"},
    {label:"4A2C", key:"A4C2"},
    {label:"4A3C", key:"A4C3"},
     {label:"5A1C", key:"A5C1"},
    {label:"5A2C", key:"A5C2"},
    {label:"5A3C", key:"A5C3"},
      {label:"6A1C", key:"A6C1"},
    {label:"6A2C", key:"A6C2"},
    {label:"6A3C", key:"A6C3"},
   
  ]
  
  const [listtourData, setlisttourData] =useState([{
    tour_name: "",
    
    tour_description: "",
    tour_city: "",
    tour_destination: "",
    
    }]);
    const [dest, setdest]=useState([])
    const [alldest, setalldest]=useState([])
    const [cities, setcities]=useState([])
    const [ratedata, setratedata] = useState([]);
    const [open, setopen]=useState(false)
    const [leadfilterData, setleadfilterData]=useState({})
    const [selection, setselection] = useState([]);
  const { appData, loading } = useAppData();
  const loadtours = async () => {
    try{
      setleadfilterData({...leadfilterData,cities:""})
    if(leadfilterData.destination=="" || leadfilterData.destination==null || leadfilterData.destination=="All" ) {
      const data = await fetchTours();
      //console.log(data);
      //const custdatalistfromdb= data.data
      setlisttourData(data.data)
      }else{
      const data = await fetchdestToursbyDest(leadfilterData.destination);
      
      const temp=alldest.filter(d=>d.dest[0]==leadfilterData.destination)
      //console.log(temp[0].cities)
      setcities(temp[0].cities)
      setlisttourData(data.data)
    
      }
    }catch(err){
      console.log(err)
    }
  }

  const getDest = async () => {
    try{
    const data = await fetchDest();
    //console.log(data.data)
    const temp=data.data.filter(d=>"order" in d)
    setalldest(data.data)
    setdest(temp[0].dest);
  }catch(err){
    console.log(err)
  }
  };
  
  useEffect(() => {
    getDest()
    
  }, [])
  var { cuser, role } = GetRole();
 
  var l1=[...listtourData]
  if(leadfilterData.cities){
    l1=l1.filter(t=>t.tour_city==leadfilterData.cities)
  }

  if(leadfilterData.advance_booking){
    l1=l1.filter(t=>t.advance_booking)
  }
  
  const tourdatalistdisplay=l1.map(tourdata=>({tour_name: tourdata.tour_name, 
    id:listtourData.indexOf(tourdata),
    tour_id:tourdata.tour_id, 
    tour_city:tourdata.tour_city, 
    advance_booking:tourdata.advance_booking, 
    tour_description:tourdata.tour_description }));
  //console.log(custdatalistfromdb);
    const tourdatalistdisplay2=l1.map(tourdata=>({tour_name: tourdata.tour_name, 
    id:listtourData.indexOf(tourdata),
    tour_id:tourdata.tour_id, 
    tour_description:tourdata.tour_description,
    A2:"normal" in tourdata?tourdata.normal.A2:0,
    A3:"normal" in tourdata?tourdata.normal.A3:0,
    A4:"normal" in tourdata?tourdata.normal.A4:0,
    A5:"normal" in tourdata?tourdata.normal.A5:0,
    A6:"normal" in tourdata?tourdata.normal.A6:0,
    A7:"normal" in tourdata?tourdata.normal.A7:0,
    A8:"normal" in tourdata?tourdata.normal.A8:0,
    A9:"normal" in tourdata?tourdata.normal.A9:0,
    A1C1:"normal" in tourdata?tourdata.normal.A1C1:0,
    A2C1:"normal" in tourdata?tourdata.normal.A2C1:0,
    A2C2:"normal" in tourdata?tourdata.normal.A2C2:0,
    A3C1:"normal" in tourdata?tourdata.normal.A3C1:0,
    A3C2:"normal" in tourdata?tourdata.normal.A3C2:0,
    A3C3:"normal" in tourdata?tourdata.normal.A3C3:0,
    A4C1:"normal" in tourdata?tourdata.normal.A4C1:0,
    A4C2:"normal" in tourdata?tourdata.normal.A4C2:0,
    A4C3:"normal" in tourdata?tourdata.normal.A4C3:0,
        A5C1:"normal" in tourdata?tourdata.normal.A5C1:0,
        A5C2:"normal" in tourdata?tourdata.normal.A5C2:0,
        A5C3:"normal" in tourdata?tourdata.normal.A5C3:0,
        A6C1:"normal" in tourdata?tourdata.normal.A6C1:0,
        A6C2:"normal" in tourdata?tourdata.normal.A6C2:0,
        A6C3:"normal" in tourdata?tourdata.normal.A6C3:0,
        A10:"normal" in tourdata?tourdata.normal.A10:0,
     }));

  const gridcelldoubleclick=(id)=>{
    window.open("/tourdataentry/" + id, '_blank');
    //console.log("/custdataentry/"+id);
  }

  const gridcellkeydown=(name, description)=>{
    alert("Tour Name: " +name + "\n\nTour Description: " + description)
    
    
  }

  const openavailability=()=>{
    setopen(true)
  }

  const handleClose=()=>{
    setopen(false)
  }

  const startdatechange = (e, tid, id) => {
    const newdata = ratedata[tid];
    //console.log(newdata)
    const newitem = { ...newdata, start_date: e.target.value };
    //console.log(newitem)
    setratedata(ratedata.map((item) => (item.id == id ? newitem : item)));
    //setdata([...data, data[tid]=newitem])
    // console.log(cpdata)
  };

  const enddatechange = (e, tid, id) => {
    const newdata = ratedata[tid];
    // console.log(tid, id)
    const newitem = { ...newdata, end_date: e.target.value };
    //console.log(newitem)
    setratedata(ratedata.map((item) => (item.id == id ? newitem : item)));
    //setdata([...data, data[tid]=newitem])
    // console.log(cpdata)
  };
  const availabilitychange = (e, tid, id) => {
    const newdata = ratedata[tid];
    // console.log(e.target)
    // console.log(tid, id)
    const newitem = { ...newdata, status: e.target.value };
    //console.log(newitem)
    setratedata(ratedata.map((item) => (item.id == id ? newitem : item)));
    //setdata([...data, data[tid]=newitem])
    // console.log(cpdata)
  };

  const addcp = () => {
    //console.log(count)

    setratedata(
      ratedata.length == 0 ? [{ id: uuidv4() }] : [...ratedata, { id: uuidv4() }]
    );
  };

  const removecp = () => {
    setratedata([...ratedata].slice(0, ratedata.length - 1));
  };

  const submitdata=()=>{
    //console.log(ratedata)
    setopen(false)
  }

  const updateavailability=async() => {
    //console.log(selection)
    
    try{

      var count=0
    for(let i=0; i<selection.length; i++){
      var temp=tourdatalistdisplay[selection[i]].tour_id
      console.log(temp)
      const data = await fetchTourbyId(temp);
      const finaltourData={...data.data, availability:ratedata}

      const updatetourResponse= await updateTourdata(data.data._id, finaltourData);
        if (
      updatetourResponse.status == 200 ||
      201 ||
      202 ||
      203 ||
      204 ||
      205 ||
      206 ||
      207
    ) {
      count++
    } else {
      alert("Something went wrong. Contact support");
      window.location = "/";
    }
    }
    if(count==selection.length){
      alert("Updated avaialbility for tour count: "+count)
    }
  }catch(err){
    console.log(err)
  }
  }

  const searchbydesc=async()=>{
     try{
    const data = await gettoursbydesc({search:leadfilterData.text});
    console.log(data.data)
    setlisttourData(data.data)
    
  }catch(err){
    console.log(err)
  }
  }

    return ( 
      <div>
      {dest.length>0 ?(
      <div>
        <Paper variant="outlined" className={classes.paper}> 
        <div align="center">
        <Typography variant="h4" align="center" className={classes.headertext}> View Tours</Typography>
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Destination">Destination</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Destination" value={leadfilterData.destination} onChange={(e)=> setleadfilterData({...leadfilterData, destination: e.target.value})}>
                
                {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
                    
                    
                
                </Select>
                </FormControl>
                {cities.length>0?(
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Cities">Cities</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Cities" value={leadfilterData.cities} onChange={(e)=> setleadfilterData({...leadfilterData, cities: e.target.value})}>
                <MenuItem value="">Clear</MenuItem>
                {cities.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
                </Select>
                </FormControl>
                ):("")}
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="AB">Advance Booking</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Cities" value={leadfilterData.advance_booking} onChange={(e)=> setleadfilterData({...leadfilterData, advance_booking: e.target.value})}>
                <MenuItem value="">Clear</MenuItem>
                <MenuItem value="Yes">Yes</MenuItem>
                </Select>
                </FormControl>
        <Button onClick={loadtours} variant="contained"  color="inherit" className={classes.button}>Load</Button>
        {role=="Admin"  || role=="Product"?(<div>
          <Button href="/tourdataentry"  variant="contained" color="primary" align="center" className={classes.button}>Add Tour</Button>
          <Button onClick={openavailability}  variant="contained" color="inherit" align="center" className={classes.button}>Availability</Button>
          <Button onClick={updateavailability}  variant="contained" color="inherit" align="center" className={classes.button}>Update</Button>
        </div>):("")}
        </div>
        {cuser=="Debayan"?(
          <div align="center">
          <TextField
                          variant="outlined"
                          label="Search text"
                          value={leadfilterData.text}
                          className={classes.textField}
                          onChange={(e) =>
                            setleadfilterData({...leadfilterData, text: e.target.value})
                          }
                        />
             <Button onClick={searchbydesc}  variant="contained" color="inherit" align="center" className={classes.button}>Search by text</Button>
          </div>
        ):("")}
        {/* {open ? <Modal open={open} onClose={handleClose}>abc</Modal> : <Modal open={open} onClose={handleClose}>def</Modal>} */}
        {tourdatalistdisplay.length>1?(<div>
                   <CSVLink data={tourdatalistdisplay} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
        <div style={{ height: 1200, width: '100%' }}>
      <DataGrid rows={tourdatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcelldoubleclick(getValue.row.tour_id)}
        columns={columns}
        autoPageSize
        // pageSize={20}
        rowHeight={50}
        checkboxSelection={true}
        onSelectionModelChange={(newSelection) => {setselection(newSelection)}}
        onCellKeyDown={(getValue)=>gridcellkeydown(getValue.row.tour_name, getValue.row.tour_description)}
        // autoHeight
        >      
      </DataGrid>      
    </div>
    </Paper>
    {cuser=="Debayan"?(
    <Paper variant="outlined" className={classes.paper}> 
        
        {/* {open ? <Modal open={open} onClose={handleClose}>abc</Modal> : <Modal open={open} onClose={handleClose}>def</Modal>} */}
        {tourdatalistdisplay2.length>1?(<div>
                   <CSVLink data={tourdatalistdisplay2} headers={headers2}>Download CSV</CSVLink>
                   </div>
                ):("")}
        <div style={{ height: 1200, width: '100%' }}>
      <DataGrid rows={tourdatalistdisplay2} 
        onCellDoubleClick={(getValue)=>gridcelldoubleclick(getValue.row.tour_id)}
        columns={columns2}
        autoPageSize
        // pageSize={20}
        rowHeight={50}
        // checkboxSelection={true}
        // onSelectionModelChange={(newSelection) => {setselection(newSelection)}}
        // onCellKeyDown={(getValue)=>gridcellkeydown(getValue.row.tour_name, getValue.row.tour_description)}
        // autoHeight
        >      
      </DataGrid>      
    </div>
    </Paper>
    ):("")}
    </div>
    ):("Loading...")}
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="m">
    {ratedata.map(item=>{
                return (<div>
                    <FormGroup row className={classes.formgroup}>
                    <TextField  style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}
            required
            variant="standard"
            type="date"
            label={"Start Date"}
            id={ratedata.indexOf(item)}
            InputLabelProps={{ shrink: true }}
            value={
                      item.start_date === undefined
                        ? ""
                        : item.start_date.split("T").slice(0, 1)
                    }
            className={classes.textField2}
            onChange={(e) => startdatechange(e, e.target.id, item.id)}
          />
          <TextField  style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}
            required
            variant="standard"
            type="date"
            label={"End Date"}
            id={ratedata.indexOf(item)}
            InputLabelProps={{ shrink: true }}
            value={
                      item.end_date === undefined
                        ? ""
                        : item.end_date.split("T").slice(0, 1)
                    }
            className={classes.textField2}
            onChange={(e) => enddatechange(e, e.target.id, item.id)}
          />
          <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel >Availability</InputLabel>
                <Select  classname={classes.textField}  required name={ratedata.indexOf(item)} labelId="city" value={item.status} onChange={(e) => availabilitychange(e, e.target.name, item.id)}>
                     <MenuItem value={"Yes"}>Yes</MenuItem>
                     <MenuItem value={"No"}>No</MenuItem>
                    
                </Select>
                </FormControl>
                    </FormGroup>
               
                </div>)
            })}
            <div align="center">
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={addcp}
            >
              {" "}
              + Tranche
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={removecp}
            >
              {" "}
              - Tranche
            </Button>
            </div>
            <div align="center">
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={submitdata}
            >
              {" "}
              Save
            </Button>
            </div>
</Dialog>
    </div>

     )
}
 
export default Listtourdata;